import { Button, FormControl, Grid, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { DOAIconComp } from "../../components/DOAIconComp";
import { DatePickerComp, DatePickerCompProps } from "../../components/DatePickerComp";
import { MainContainer } from "../../components/MainContainerComp";
import { REPORT_DISPATCH_TYPES } from "./CasualAuditReportModels";
import { GridItemStyle, SelectMenuStyle, asteriskStyle, buttonContainerStyle, buttonStyle, descriptionStyle } from "./styled";

interface ICasualAuditReportProps {
  datePickerCompProps: DatePickerCompProps;
  dispatchType: string;
  disabledView: boolean;
  handleSubmit: () => void;
  handleShiftChange: (event: SelectChangeEvent<string>) => void;
}

export const CasualAuditReport: React.FC<ICasualAuditReportProps> = ({
  datePickerCompProps,
  dispatchType,
  disabledView,
  handleSubmit,
  handleShiftChange,
}) => {
  return (
    <MainContainer>
      <DOAIconComp />
      <Typography sx={descriptionStyle} data-automation="description-text">
        The Casual Audit Report will display Declaration of Availability Statistics for a given date and dispatch.
        The report includes casual employees only.
      </Typography>
      <DatePickerComp {...datePickerCompProps} />
      <Grid sx={{ justifyContent: 'center' }} container>
        <Grid item xs={12} md={4} sx={GridItemStyle}>
          <FormControl fullWidth>
            <Typography data-automation="dispatch-lbl">Dispatch <Typography component={"span"} sx={asteriskStyle}>*</Typography></Typography>
            <Select
              displayEmpty
              value={dispatchType}
              onChange={handleShiftChange}
              MenuProps={{ sx: SelectMenuStyle }}
              data-automation="shift-options"
            >
              {REPORT_DISPATCH_TYPES.map(({ code, display }) => (
                <MenuItem key={code} value={code}>
                  {display}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid sx={{ justifyContent: 'center' }} container>
        <Grid sx={buttonContainerStyle} item xs={12} md={8}>
          <Button
            sx={buttonStyle}
            onClick={handleSubmit}
            disabled={disabledView}
            variant="contained"
            size="medium"
            data-automation="view-btn"
          >
            View Report
          </Button>
        </Grid>
      </Grid>
    </MainContainer>
  )
}